import axios from "axios";

let homeStartTime = 0;
let homeTime = 0;
let homeVisit = 0;
let projectsStartTime = 0;
let projectsTime = 0;
let projectsVisit = 0;
let expStartTime = 0;
let expTime = 0;
let expVisit = 0;
let aboutStartTime = 0;
let aboutTime = 0;
let aboutVisit = 0;
let contactStartTime = 0;
let contactTime = 0;
let contactVisit = 0;

let lightsVisit = 0;
let lightsOff = true;
let ticVisit = 0;
let bshipsVisit = 0;
let enigmaVisit = 0;
let fiaVisit = 0;
let enerfyVisit = 0;
let cvVisit = 0;
let musicVisit = 0;
let linkedinVisit = 0;
let githubVisit = 0;
let fbVisit = 0;
let emailVisit = 0;

let afkTime = 0;
let wasActiveCount = "";
let isFocus = false;
let avoidSpam = true;
let clickedBeforeFocus = true;

let statsUser = localStorage.getItem("Stats_User");

const avoidSpamTime = 500; //ms
const afkMinuteTime = 5; //min

// On close or refresh of the site send the stats to the server
window.addEventListener("beforeunload", function (e) {
    e.preventDefault();
    clickedBeforeFocus = true;
    saveCategoriesStats();
    e.returnValue = "";
});

// On site focus start again the timer
window.addEventListener(
    "focus",
    function () {
        setTimeout(() => {
            if (!clickedBeforeFocus) {
                isFocus = true;
                categoriesCount(wasActiveCount);
            }
        }, 200);
    },
    false
);

// On site blur stop all count timers
window.addEventListener(
    "blur",
    function () {
        stopAllCounts();
        clickedBeforeFocus = false;
    },
    false
);

// Count the time and visits of site's categories
export default function categoriesCount(val) {
    clickedBeforeFocus = true;
    if (!avoidSpam) {
        return;
    }
    avoidSpam = false;

    clearTimeout(afkTime);
    afkTime = 0;
    // stop all counts if the user is afk for "5min"
    afkTime = setTimeout(stopAllCounts, 1000 * 60 * afkMinuteTime);

    if (val === "home") {
        homeStartTime = new Date();
        if (!isFocus) {
            homeVisit = homeVisit + 1;
        }
        wasActiveCount = val;

        endProjectsTime();
        endExpTime();
        endAboutTime();
        endContactTime();
    } else if (val === "proj") {
        projectsStartTime = new Date();
        if (!isFocus) {
            projectsVisit = projectsVisit + 1;
        }
        wasActiveCount = val;

        endHomeTime();
        endExpTime();
        endAboutTime();
        endContactTime();
    } else if (val === "exp") {
        expStartTime = new Date();
        if (!isFocus) {
            expVisit = expVisit + 1;
        }
        wasActiveCount = val;

        endHomeTime();
        endProjectsTime();
        endAboutTime();
        endContactTime();
    } else if (val === "about") {
        aboutStartTime = new Date();
        if (!isFocus) {
            aboutVisit = aboutVisit + 1;
        }
        wasActiveCount = val;

        endHomeTime();
        endProjectsTime();
        endExpTime();
        endContactTime();
    } else if (val === "cont") {
        contactStartTime = new Date();
        if (!isFocus) {
            contactVisit = contactVisit + 1;
        }
        wasActiveCount = val;

        endHomeTime();
        endProjectsTime();
        endExpTime();
        endAboutTime();
    }
    isFocus = false;

    setTimeout(() => {
        avoidSpam = true;
    }, avoidSpamTime);
}

// Functions for stopping time counters
function endHomeTime() {
    if (homeStartTime !== 0) {
        const endTime = new Date();
        let timeDiff = endTime - homeStartTime; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds
        homeTime = Math.round(timeDiff) + homeTime;
        homeStartTime = 0;
    }
}

function endProjectsTime() {
    if (projectsStartTime !== 0) {
        const endTime = new Date();
        let timeDiff = endTime - projectsStartTime; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds
        projectsTime = Math.round(timeDiff) + projectsTime;
        projectsStartTime = 0;
    }
}

function endExpTime() {
    if (expStartTime !== 0) {
        const endTime = new Date();
        let timeDiff = endTime - expStartTime; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds
        expTime = Math.round(timeDiff) + expTime;
        expStartTime = 0;
    }
}

function endAboutTime() {
    if (aboutStartTime !== 0) {
        const endTime = new Date();
        let timeDiff = endTime - aboutStartTime; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds
        aboutTime = Math.round(timeDiff) + aboutTime;
        aboutStartTime = 0;
    }
}

function endContactTime() {
    if (contactStartTime !== 0) {
        const endTime = new Date();
        let timeDiff = endTime - contactStartTime; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds
        contactTime = Math.round(timeDiff) + contactTime;
        contactStartTime = 0;
    }
}

function stopAllCounts() {
    endHomeTime();
    endProjectsTime();
    endExpTime();
    endAboutTime();
    endContactTime();
}

// Count the "clicks" of the btns in site
window.itemCount = function (val) {
    if (!avoidSpam) {
        return;
    }
    avoidSpam = false;

    if (val === "tic") {
        ticVisit = ticVisit + 1;
    } else if (val === "bships") {
        bshipsVisit = bshipsVisit + 1;
    } else if (val === "enigma") {
        enigmaVisit = enigmaVisit + 1;
    } else if (val === "music") {
        musicVisit = musicVisit + 1;
    } else if (val === "fb") {
        fbVisit = fbVisit + 1;
    } else if (val === "linkedin") {
        linkedinVisit = linkedinVisit + 1;
    } else if (val === "github") {
        githubVisit = githubVisit + 1;
    } else if (val === "email") {
        emailVisit = emailVisit + 1;
    } else if (val === "cv") {
        cvVisit = cvVisit + 1;
    } else if (val === "lights") {
        if (lightsOff) {
            lightsVisit = lightsVisit + 1;
            lightsOff = false;
        } else {
            lightsOff = true;
        }
    }

    setTimeout(() => {
        avoidSpam = true;
    }, avoidSpamTime);
};

// Save all stats and send the results to the server
function saveCategoriesStats() {
    stopAllCounts();

    const allStats = {
        statsUser: statsUser,
        homeTime: homeTime,
        homeVisit: homeVisit,
        projectsTime: projectsTime,
        projectsVisit: projectsVisit,
        expTime: expTime,
        expVisit: expVisit,
        aboutTime: aboutTime,
        aboutVisit: aboutVisit,
        contactTime: contactTime,
        contactVisit: contactVisit,
        ticVisit: ticVisit,
        enigmaVisit: enigmaVisit,
        fiaVisit: fiaVisit,
        enerfyVisit: enerfyVisit,
        musicVisit: musicVisit,
        fbVisit: fbVisit,
        linkedinVisit: linkedinVisit,
        githubVisit: githubVisit,
        emailVisit: emailVisit,
        lightsVisit: lightsVisit,
        bshipsVisit: bshipsVisit
    };

    axios
        .post("/savestats", allStats)
        .then((response) => {})
        .catch((error) => {});
}

// Set for new user a random name and save it in localStorage
if (statsUser === null) {
    const newStatsUser = generateId(15);
    localStorage.setItem("Stats_User", newStatsUser);
    statsUser = newStatsUser;
}

// dec2hex :: Integer -> String
// i.e. 0-255 -> '00'-'ff'
function dec2hex(dec) {
    return dec.toString(16).padStart(2, "0");
}

// generateId :: Integer -> String
function generateId(len) {
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, dec2hex).join("");
}
